import { render } from "./SearchForm.vue?vue&type=template&id=08b4e728&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=08b4e728&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08b4e728"

export default script